<div class="top-toolbar-panel">
  <button
    type="button"
    class="toolbar-btn help-btn"
    [title]="translations().helpTitle"
    [attr.aria-label]="translations().helpAriaLabel"
    (click)="onHelpClick()"
  >
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <use href="/assets/icons/sprite.svg#icon-help"></use>
    </svg>
  </button>

  <button
    type="button"
    class="toolbar-btn download-btn"
    [title]="translations().downloadTitle"
    [attr.aria-label]="translations().downloadAriaLabel"
    (click)="onDownloadClick()"
  >
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" class="svg-icon">
      <use href="/assets/icons/sprite.svg#icon-download"></use>
    </svg>
  </button>

  <button
    type="button"
    class="toolbar-btn share-btn"
    [title]="translations().shareTitle"
    [attr.aria-label]="translations().shareAriaLabel"
    (click)="onShareClick()"
  >
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <use href="/assets/icons/sprite.svg#icon-share"></use>
    </svg>
  </button>
</div>
